export enum NotificationType {
  Success = "notificationGreen",
  Error = "notificationRed",
  Info = "notificationBlue",
  Warning = "notificationYellow"
};
